interface AdminDashboardCardProps {
  readonly title: string;
  readonly value: string;
  readonly note: string;
}

export function AdminDashboardCard({ title, value, note }: AdminDashboardCardProps) {
  return (
    <article className="admin-panel admin-metric-card">
      <h2>{title}</h2>
      <strong>{value}</strong>
      <p>{note}</p>
    </article>
  );
}
